import { useState } from "react";
import { RotateCw, Loader2 } from "lucide-react";
import { ImageLightbox } from "./ImageLightbox";

export const TurntableStrip = ({ views = [], busy = false }) => {
  const [idx, setIdx] = useState(-1);
  if (!views.length) return null;
  const images = views.map((v) => v.image);
  return (
    <div data-testid="turntable-strip" className="relative rounded-3xl border border-border bg-card/60 p-3">
      {busy && (
        <div data-testid="turntable-repainting" className="absolute inset-0 z-10 flex flex-col items-center justify-center gap-2 rounded-3xl bg-background/85 backdrop-blur-sm">
          <Loader2 className="h-6 w-6 text-accent animate-spin" />
          <p className="text-sm font-bold">Repainting…</p>
        </div>
      )}
      <p className="flex items-center gap-2 text-xs font-mono2 uppercase tracking-widest text-muted-foreground mb-2">
        <RotateCw className="h-4 w-4" /> Printed mesh · turntable
      </p>
      <ul className="grid grid-cols-4 gap-2">
        {views.map((v, i) => (
          <li key={v.view} data-testid={`turntable-${v.view}`} className="rounded-2xl overflow-hidden border border-border bg-[#f6f4ef]">
            <button
              type="button"
              onClick={() => setIdx(i)}
              data-testid={`turntable-open-${v.view}`}
              aria-label={`Enlarge ${v.view} view`}
              className="block w-full hover:opacity-90 transition-opacity"
            >
              <img src={v.image} alt={`${v.view} view of the printed mesh`} className="w-full aspect-square object-cover" />
            </button>
            <p className="text-[10px] font-mono2 uppercase tracking-widest text-center py-1 bg-background/90">{v.view}</p>
          </li>
        ))}
      </ul>
      <ImageLightbox
        open={idx >= 0}
        onOpenChange={(o) => !o && setIdx(-1)}
        images={images}
        index={Math.max(0, idx)}
        onIndexChange={setIdx}
        alt="turntable view"
      />
    </div>
  );
};
